// @flow

import * as React from 'react';
import './Footnote.scss';

type FootnoteProps = {|
  children: React.Node,
|};

export const Footnote = ({children}: FootnoteProps) => (
  <div className="Footnote">{children}</div>
);
